import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Space, Select, Row, message } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGenerateZeroReceipt } from 'RKSV/hooks/logs';
import { NULL_RECEIPT, MONTHLY_RECEIPT, YEARLY_RECEIPT } from '../constants';

const { Option } = Select;

const SelectWrapper = styled.div`
  display: inline-block;
  padding-top: 20px;
`;

const ZeroReceiptContainer = () => {
  const { status, mutate: generateZeroReceipt } = useGenerateZeroReceipt();
  const isLoading = status === 'pending';
  const intl = useIntl();
  useEffect(() => {
    if (isLoading) {
      message.loading(
        intl.formatMessage({
          defaultMessage: 'The receipt is being generated',
        })
      );
    }
  }, [intl, isLoading]);
  return (
    <Row>
      <Space>
        <SelectWrapper>
          <FormattedMessage defaultMessage="Generate custom receipt" />
          <Select
            disabled={isLoading}
            style={{
              width: 210,
              marginLeft: 10,
            }}
            placeholder="Select a receipt type"
            onChange={(value: string) =>
              generateZeroReceipt({ receiptType: value })
            }
          >
            <Option value={NULL_RECEIPT}>
              <FormattedMessage defaultMessage="Null Receipt" />
            </Option>
            <Option value={MONTHLY_RECEIPT}>
              <FormattedMessage defaultMessage="Monthly Receipt" />
            </Option>
            <Option value={YEARLY_RECEIPT}>
              <FormattedMessage defaultMessage="Yearly Receipt" />
            </Option>
          </Select>
        </SelectWrapper>
      </Space>
    </Row>
  );
};
export default ZeroReceiptContainer;
